import {
  Component, Input, Output, EventEmitter,
  ViewChild, ElementRef, OnDestroy, AfterViewInit, OnChanges, SimpleChanges, HostListener
} from '@angular/core';
import Hls from 'hls.js';

@Component({
  selector: 'app-hls-overlay-player',
  templateUrl: './inspark-overlay-hls-video.component.html',
  styleUrls: ['./inspark-overlay-hls-video.component.scss']
})
export class InsparkOverlayHlsVideoComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() streamUrl!: string ;            // например: 'http://10.3.2.103/media-gate/hls/8569/stream.m3u8'
  @Input() autoPlayMuted: boolean = true; // для автоплея в браузерах
  @Output() closed = new EventEmitter<void>();

  @ViewChild('videoEl') videoRef!: ElementRef<HTMLVideoElement>;
  private hls?: Hls;
  isLoading = true;
  errorMsg: string | null = null;

  ngAfterViewInit(): void {
    if (this.streamUrl) {
      this.initPlayer(this.streamUrl);
    }
    // Заблокируем прокрутку body, пока открыт оверлей
    document.body.style.overflow = 'hidden';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['streamUrl'] && !changes['streamUrl'].firstChange && this.videoRef) {
      this.reinit(changes['streamUrl'].currentValue);
    }
  }

  private reinit(url: string) {
    this.destroyPlayer();
    this.isLoading = true;
    this.errorMsg = null;
    this.initPlayer(url);
  }

  private initPlayer(url: string) {
    const video = this.videoRef.nativeElement;
    video.muted = this.autoPlayMuted;
    video.playsInline = true;

    if (Hls.isSupported()) {
      this.hls = new Hls({
        // Опционально: тонкая настройка буфера/задержки
        enableWorker: true,
        lowLatencyMode: true
      });
      this.hls.loadSource(url);
      this.hls.attachMedia(video);

      this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
        this.isLoading = false;
        video.play().catch(() => {
          // Если автоплей запрещен — просто показываем контролы
          this.errorMsg = null;
        });
      });

      this.hls.on(Hls.Events.ERROR, (_evt, data) => {
        if (data.fatal) {
          switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              this.errorMsg = 'Сетевая ошибка. Переподключение...';
              this.hls?.startLoad();
              break;
            case Hls.ErrorTypes.MEDIA_ERROR:
              this.errorMsg = 'Медиа ошибка. Восстановление...';
              this.hls?.recoverMediaError();
              break;
            default:
              this.errorMsg = 'Критическая ошибка плеера';
              this.close();
          }
        }
      });
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      // Safari (нативная поддержка HLS)
      video.src = url;
      video.addEventListener('loadedmetadata', () => {
        this.isLoading = false;
        video.play().catch(() => {});
      });
    } else {
      this.isLoading = false;
      this.errorMsg = 'Браузер не поддерживает HLS';
    }
  }

  togglePlay() {
    const video = this.videoRef.nativeElement;
    if (video.paused) {video.play();}
    else {video.pause();}
  }

  close() {
    this.destroyPlayer();
    document.body.style.overflow = ''; // вернуть прокрутку
    this.closed.emit();
  }

  private destroyPlayer() {
    try {
      const video = this.videoRef?.nativeElement;
      video?.pause();
      if (this.hls) {
        this.hls.destroy();
        this.hls = undefined;
      }
      if (video) {
        video.removeAttribute('src');
        video.load();
      }
    } catch {}
  }

  @HostListener('document:keydown.escape')
  onEsc() {
    this.close();
  }

  ngOnDestroy(): void {
    this.destroyPlayer();
    document.body.style.overflow = '';
  }
}
